class WonderWallBrandDirectory extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const options = {signal:this.controller.signal};
    try {
      const supplied = JSON.parse(this.dataset.vendors);
      if (!Array.isArray(supplied) || supplied.some(v=>typeof v!=='string')) return;
      const collator = new Intl.Collator(document.documentElement.lang || 'en',{sensitivity:'base',numeric:true});
      this.vendors = [...new Set(supplied)].sort(collator.compare);
    } catch { return; }
    this.search = this.querySelector('[data-brand-search]');
    this.list = this.querySelector('[data-brand-list]');
    this.status = this.querySelector('[data-brand-status]');
    this.more = this.querySelector('[data-brand-more]');
    this.letter ||= '';this.limit ||= 30;
    this.fold = value=>value.normalize('NFD').replace(/\p{Diacritic}/gu,'').toLocaleLowerCase();
    this.search.addEventListener('input',()=>{
      clearTimeout(this.timer);
      this.timer=setTimeout(()=>{this.limit=30;this.render();},150);
    },options);
    this.addEventListener('click',event=>{
      const letter=event.target.closest('[data-brand-letter]');
      if(letter){clearTimeout(this.timer);this.letter=letter.dataset.brandLetter;this.limit=30;this.render();}
      if(event.target.closest('[data-brand-more]')){this.limit+=30;this.render();}
    },options);
    this.render();
  }
  disconnectedCallback(){clearTimeout(this.timer);this.controller?.abort();}
  render(){
    const term=this.fold(this.search.value.trim());
    const matches=this.vendors.filter(name=>{
      const folded=this.fold(name);
      const first=folded.slice(0,1).toUpperCase();
      return (!term||folded.includes(term))&&(!this.letter||(this.letter==='#'?!/^[A-Z]$/.test(first):first===this.letter));
    });
    const visible=matches.slice(0,this.limit),fragment=document.createDocumentFragment();
    for(const name of visible){
      const link=document.createElement('a');
      const url=new URL(this.dataset.baseUrl,location.origin);
      url.searchParams.set('q',name);url.searchParams.set('filter.v.availability','1');
      link.href=url.pathname+url.search;link.textContent=name;fragment.append(link);
    }
    this.list.replaceChildren(fragment);
    this.status.textContent=matches.length?`${visible.length} / ${matches.length} ${this.dataset.countLabel}`:this.dataset.emptyLabel;
    this.more.hidden=visible.length>=matches.length;
    this.querySelectorAll('[data-brand-letter]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.brandLetter===this.letter)));
    this.dataset.sourceCount=String(this.vendors.length);this.dataset.matchCount=String(matches.length);
  }
}
if(!customElements.get('ww-brand-directory'))customElements.define('ww-brand-directory',WonderWallBrandDirectory);
